import { KeyOrFn, LabeledValueType, Tooltip } from '../types'

/**
 * helps transform a list of `T` into a list of {@link LabeledValueType} for the
 * CIMSSelect component
 *
 * @param items items to parse
 * @param options {@link ToLabeledValuesOptions}
 */
export function toLabeledValues<T>(
  items: T[] | undefined | null,
  options:
    | {
        /**
         * resolve each item using the following callback
         */
        type: 'callback'
        /**
         * the callback used to resolve each item
         */
        callback: (item: T) => LabeledValueType
      }
    | ToLabeledValuesOptions<T>
) {
  return (items ?? []).map<LabeledValueType>((item) => {
    if (options.type === 'callback') return options.callback(item)
    const { value, deleted, label, tooltip: tip } = options
    const tooltip = typeof tip === 'function' ? tip(item) : tip && item[tip]
    return {
      value:
        typeof value === 'function'
          ? value(item)
          : (item[value] as string | number),
      label: typeof label === 'function' ? label(item) : item[label],
      deleted: deleted?.(item),
      tooltip: tooltip?.toString(),
    }
  })
}

export type ToLabeledValuesOptions<T = unknown> = Tooltip<
  KeyOrFn<T, string | null | undefined>
> & {
  type?: 'options'
  /**
   * the value to use
   */
  value: KeyOrFn<T, string | number>
  /**
   * the label to use
   */
  label: KeyOrFn<T, React.ReactNode>
  /**
   * a callback to determine whether the item is deleted or not. thanks geo entities
   *
   * overwrites any supplied {@link tooltip} values
   */
  deleted?: (item: T) => boolean | undefined
}
